export const PRODUCT_LOADING = 'waitrose/products/PRODUCT_LOADING' as const;
export const PRODUCT_LOADED = 'waitrose/products/PRODUCT_LOADED' as const;
export const PRODUCT_FAILED = 'waitrose/products/PRODUCT_FAILED' as const;
export const PRODUCT_NOT_FOUND = 'waitrose/products/PRODUCT_NOT_FOUND' as const;
export const PDP_RECOMMENDED_PRODUCTS_FULFILLED =
  'waitrose/recommendations/products/RECOMMENDED_PRODUCTS_FULFILLED';
